module.exports = {"621225100":"汉源镇","621225101":"长道镇","621225102":"何坝镇","621225103":"姜席镇","621225104":"石峡镇","621225105":"洛峪镇","621225106":"西峪镇","621225107":"马元镇","621225108":"大桥镇","621225109":"十里镇","621225110":"石堡镇","621225111":"兴隆镇","621225112":"苏合镇","621225113":"卢河镇","621225114":"稍峪镇","621225115":"西高山镇","621225208":"晒经乡","621225217":"蒿林乡","621225218":"太石河乡","621225220":"六巷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621225.json
// module id = 2959
// module chunks = 0